
export default class Search {

	constructor() {
		this.initEvents();
	}

	initEvents() {
		//click event reset search
		return $('.js-reset-search').on('click', function (e) {
			e.preventDefault();
			$('.search-form-wrapper').show();
			return $('.search-result-wrapper').hide();
		});
	}
}